module.exports = __webpack_public_path__ + "static/img/Awards.1e0027e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/Awards.png
// module id = Vpl1
// module chunks = 0